// Types
import mixins from "vue-typed-mixins";
// Utils
import camelCase from 'lodash/camelCase';
import merge from 'lodash/merge';
import isObject from 'lodash/isObject';
import consola from 'consola';

// Mixins
import { InjectFrom, InjectFromTwo } from '../utils/withInject';
const dummyInject = InjectFrom().keys('dummyMode');
const layoutElementInject = InjectFrom().keys('sectionName');
const editorContainerInject = InjectFrom().keys('registerEditor', 'unregisterEditor', 'registeredEditors');

// todo: type correctly
const sectionInject = InjectFromTwo().keys('setComponentMeta');
const componentDataInject = InjectFrom().keys('componentData');
function ensureValue(value, defaultValue) {
  // if value is not defined, then we return default value anyway, doesn't matter what it is
  if (value === undefined || value === null) return defaultValue;

  // if there is no default value, then there is nothing to check by
  if (defaultValue === undefined || defaultValue === null) return value;

  // For now we will keep it simple and only handle objects to make sure no keys
  // from default value are missing - that could happen if we add new keys
  // and load value from existing section that still doesn't have them
  if (isObject(value) && isObject(defaultValue)) return merge(defaultValue, value);
  return value;
}
export function isElementComponent(data) {
  return data.type === 'static-element';
}
const EditorBase = defaultValue => mixins(layoutElementInject, sectionInject, componentDataInject, dummyInject, editorContainerInject).extend({
  props: {
    name: {
      type: String
    },
    value: {
      type: [String, Number, Object]
    },
    iteratorClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    duplicateEditorNames() {
      if (!this.registeredEditors) return false;
      return this.registeredEditors.filter(editor => editor.name === this.computedName).length > 1;
    },
    sectionMeta() {
      const {
        componentData
      } = this;
      if (!componentData) return;
      return isElementComponent(componentData) ? componentData.meta : componentData.linkMeta;
    },
    computedValue: {
      get() {
        const {
          computedName,
          sectionMeta
        } = this;
        // TODO: this is hacked to hell with all the type casting
        const normalisedDefaultValue = defaultValue();
        if (!computedName) return ensureValue(this.value, normalisedDefaultValue);
        if (!sectionMeta) return normalisedDefaultValue;
        return ensureValue(sectionMeta[computedName], normalisedDefaultValue);
      },
      set(value) {
        const {
          componentData,
          computedName
        } = this;
        if (!computedName) {
          this.$emit('input', value);
          return;
        }
        if (!componentData) {
          consola.error('Editor ' + this.name + ' is not in section.');
          return;
        }
        if (isElementComponent(componentData)) {
          var _this$setComponentMet;
          return (_this$setComponentMet = this.setComponentMeta) === null || _this$setComponentMet === void 0 ? void 0 : _this$setComponentMet.call(this, componentData, computedName, value);
        } else {
          var _this$setComponentMet2;
          return (_this$setComponentMet2 = this.setComponentMeta) === null || _this$setComponentMet2 === void 0 ? void 0 : _this$setComponentMet2.call(this, componentData, computedName, value);
        }
      }
    },
    computedName() {
      return camelCase(this.name);
    }
  },
  mounted() {
    var _this$registerEditor;
    this.computedName && ((_this$registerEditor = this.registerEditor) === null || _this$registerEditor === void 0 ? void 0 : _this$registerEditor.call(this, {
      name: this.computedName,
      instance: this
    }));
  },
  destroyed() {
    var _this$unregisterEdito;
    this.computedName && ((_this$unregisterEdito = this.unregisterEditor) === null || _this$unregisterEdito === void 0 ? void 0 : _this$unregisterEdito.call(this, {
      name: this.computedName,
      instance: this
    }));
  }
});
export default EditorBase;